import React from "react";
import { Box } from "@mui/material";
import { QuestionCard } from "../shared/QuestionCard";
import { WeightSlider } from "../form/WeightSlider";

type Props = {
  dogName: string;
  value: number | "";
  onChange: (weight: number | "") => void;
};

export function WeightQuestion({ dogName, value, onChange }: Props) {
  return (
    <QuestionCard title={`How heavy is ${dogName || "your dog"}?`} field="weight">
      {/* Weight slider */}
      <Box sx={{ width: "100%", maxWidth: 500 }}>
        <WeightSlider value={value} onChange={onChange} />
      </Box>
    </QuestionCard>
  );
}
